import { combineActions, handleActions } from 'redux-actions'

import * as actions from './actions'
import { MeetingState } from './models'

export default handleActions(
  {
    [actions.fetchMeetingSettingsSuccess]: (state, action) => {
      return state.setIn(['meeting'], action.payload).setIn(['meetingStatus'], 'success')
    },
    [actions.fetchMeetingSettingsFailure]: state => {
      return state.setIn(['meetingStatus'], 'failed')
    },
    [actions.updateMeetingSettingsPending]: state => {
      return state.setIn(['meetingStatus'], 'pending')
    },
    [actions.updateMeetingSettingsSuccess]: (state, action) => {
      return state.setIn(['meeting'], action.payload).setIn(['meetingStatus'], 'success')
    },
    [actions.updateMeetingSettingsFailure]: state => {
      return state.setIn(['meetingStatus'], 'failure')
    },
    [actions.fetchCalendlyMeetingTypesSuccess]: state => {
      return state.setIn(['calendlyMeetingTypesStatus'], 'success')
    },
    [actions.fetchCalendlyMeetingTypesPending]: state => {
      return state.setIn(['calendlyMeetingTypesStatus'], 'pending')
    },
    [actions.fetchCalendlyMeetingTypesFailure]: state => {
      return state.setIn(['calendlyMeetingTypesStatus'], 'failure')
    },
    [actions.fetchMeetingTypesSuccess]: (state, action) => {
      return state.setIn(['meetingTypes'], action.payload).setIn(['meetingTypesStatus'], 'success')
    },
    [actions.fetchMeetingTypesPending]: state => {
      return state.setIn(['meetingTypesStatus'], 'pending')
    },
    [actions.updateMeetingTypePending]: state => {
      return state.setIn(['meetingTypesStatus'], 'pending')
    },
    [actions.updateMeetingTypeSuccess]: (state, { payload }) => {
      const filterSlug = payload.oldSlug || payload.slug
      const existingMeetingTypes = state.get('meetingTypes').filter(mt => mt.slug !== filterSlug)
      return state
        .set('meetingTypes', existingMeetingTypes.concat(payload))
        .set('meetingTypesStatus', 'success')
    },
    [actions.updateMeetingTypeFailure]: state => {
      return state.setIn(['meetingTypesStatus'], 'failure')
    },
    [actions.updateMeetingSettingsNewAppointments]: (state, action) => {
      return state.setIn(['meeting', 'allowNewAppointments'], action.payload)
    },
    [actions.fetchMicrosoftAdminConsentPending]: (state, action) => {
      return state.set('fetchMicrosoftAdminConsentStatus', 'pending')
    },
    [actions.fetchMicrosoftAdminConsentSuccess]: (state, action) => {
      return state.set('connected', false)
                  .set('microsoftCalendarAdminManaged', action.payload)
                  .set('fetchMicrosoftAdminConsentStatus', 'success')
    },
    [actions.fetchMicrosoftAdminConsentFailure]: state => {
      return state.set('connected', false)
                  .set('microsoftCalendarAdminManaged', false)
                  .set('fetchMicrosoftAdminConsentStatus', 'failed')
    },
    [actions.disconnectMicrosoftAdminConsentSuccess]: state => {
      return state.set('connected', false)
                  .set('microsoftCalendarAdminManaged', false)
    },
    [actions.disconnectMicrosoftAdminConsentFailure]: state => {
      return state.set('microsoftCalendarAdminError', true)
    },
    [actions.microsoftAdminManagedAcceptSuccess]: (state, action) => {
      return state.set('connected', false)
                  .set('microsoftCalendarAdminError', false)
                  .set('microsoftCalendarAdminManaged', true)
                  .set('microsoftCalendarAdminIds', action.payload)
    },
    [actions.microsoftAdminManagedAcceptFailure]: (state, action) => {
      return state.set('connected', false).set('microsoftCalendarAdminManaged', false)
    },
    [actions.fetchMicrosoftManagedCalendarsPending]: (state, action) => {
      return state.set('fetchMicrosoftGlobalCalendarStatus', 'pending')
    },
    [actions.fetchMicrosoftManagedCalendarsSuccess]: (state, action) => {
      return state.set('microsoftCalendarAdminIds', action.payload)
                  .set('fetchMicrosoftGlobalCalendarStatus', 'success')
                  .set('microsoftCalendarAdminError', false)
    },
    [actions.fetchMicrosoftManagedCalendarsFailure]: (state, action) => {
      return state.set('microsoftCalendarAdminError', true)
                  .set('fetchMicrosoftGlobalCalendarStatus', 'failure')
    },
    [actions.googleOauthAcceptSuccess]: state => {
      return state.set('connected', false).set('googleAuthed', true).set('googleAuthedError', false)
    },
    [actions.googleOauthAcceptFailure]: state => {
      return state.set('connected', false).set('googleAuthed', false).set('googleAuthedError', true)
    },
    [actions.microsoftOauthAcceptSuccess]: state => {
      return state.set('connected', false).set('microsoftAuthed', true)
    },
    [actions.microsoftOauthAcceptFailure]: state => {
      return state.set('connected', false).set('microsoftAuthed', false)
    },
    [actions.zoomOauthAcceptSuccess]: state => {
      return state.set('connected', false).set('zoomAuthed', true).set('zoomAuthedError', false)
    },
    [actions.zoomOauthAcceptFailure]: state => {
      return state.set('connected', false).set('zoomAuthed', false).set('zoomAuthedError', true)
    },
    [actions.fetchCalendarStatusPending]: state => {
      return state.set('calendarStatusFetchStatus', 'pending')
    },
    [actions.fetchCalendarStatusSuccess]: (state, action) => {
      return state
        .set('connected', action.payload.connected)
        .set('calendar', action.payload.calendar)
        .set('googleAuthed', action.payload.googleAuthed)
        .set('microsoftAuthed', action.payload.microsoftAuthed)
        .set('calendarStatusFetchStatus', 'success')
        .set('isTokenRevoked', action.payload.isTokenRevoked)
    },
    [actions.fetchCalendarStatusFailure]: state => {
      return state.set('calendarStatusFetchStatus', 'failure')
    },
    [combineActions(actions.updateGoogleCalendarSuccess, actions.updateMicrosoftCalendarSuccess)]: (
      state,
      action
    ) => {
      return state.set('calendar', action.payload).set('connected', true)
    },
    [combineActions(actions.fetchGoogleCalendarsSuccess, actions.fetchMicrosoftCalendarsSuccess)]: (
      state,
      action
    ) => {
      return state.set('calendars', action.payload)
    },
    [actions.fetchGoogleScopesSuccess]: (state, action) => {
      return state.set('scopes', action.payload)
    },
    [combineActions(actions.updateGoogleCalendarPending, actions.updateMicrosoftCalendarPending)]: state => {
      return state.set('connected', true)
    },
    [combineActions(actions.updateGoogleCalendarFailure, actions.updateMicrosoftCalendarFailure)]: state => {
      return state.set('connected', false)
    },
    [combineActions(
      actions.disconnectGoogleCalendarPending,
      actions.disconnectMicrosoftCalendarPending
    )]: state => {
      return state.set('connected', false)
    },
    [combineActions(
      actions.disconnectGoogleCalendarFailure,
      actions.disconnectMicrosoftCalendarFailure
    )]: state => {
      return state.set('connected', true)
    },
    [actions.disconnectGoogleCalendarSuccess]: state => {
      return state.withMutations(state => {
        return state
          .set('connected', false)
          .set('scopes', [])
          .set('googleAuthed', undefined)
          .delete('calendar')
          .delete('calendars')
      })
    },
    [actions.disconnectMicrosoftCalendarSuccess]: state => {
      return state.withMutations(state => {
        return state
          .set('connected', false)
          .set('microsoftAuthed', undefined)
          .delete('calendar')
          .delete('calendars')
      })
    },
    [actions.fetchGoogleCalendarsPending]: state => {
      return state.set('googleCalendarsFetchStatus', 'pending')
    },
    [actions.fetchGoogleCalendarsSuccess]: state => {
      return state.set('googleCalendarsFetchStatus', 'success')
    },
    [actions.fetchGoogleCalendarsFailure]: state => {
      return state.set('googleCalendarsFetchStatus', 'failure')
    },
    [actions.fetchMicrosoftCalendarsPending]: state => {
      return state.set('microsoftCalendarsFetchStatus', 'pending')
    },
    [actions.fetchMicrosoftCalendarsSuccess]: state => {
      return state.set('microsoftCalendarsFetchStatus', 'success')
    },
    [actions.fetchMicrosoftCalendarsFailure]: state => {
      return state.set('microsoftCalendarsFetchStatus', 'failure')
    },
    [actions.fetchConnectedCalendarsPending]: state => {
      return state.set('agentIdsWithConnectedCalendarsStatus', 'pending')
    },
    [actions.fetchConnectedCalendarsSuccess]: (state, action) => {
      return state
        .set('agentIdsWithConnectedCalendarsStatus', 'success')
        .set('agentIdsWithConnectedCalendars', action.payload)
    },
    [actions.fetchConnectedCalendarsFailure]: state => {
      return state.set('agentIdsWithConnectedCalendarsStatus', 'failure')
    },
    [actions.shareRoutedCalendar]: state => {
      return state.set('shareRoutedCalendarLoading', true) 
    },
    [combineActions(
      actions.shareRoutedCalendarSuccess,
      actions.shareRoutedCalendarFailure
    )]: (state) => {
      return state.set('shareRoutedCalendarLoading', false)
    }
  },
  new MeetingState()
)



// WEBPACK FOOTER //
// ./src/scripts/app/modules/meetings/reducer.js